exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popover {\r\n  padding: 0px 12px 18px 12px;\n}\r\n", ""]);

// exports
